import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const Auth = () => {
  if (!localStorage.getItem("authToken")) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};
